export default "__VITE_ASSET__DEOq_BjF__"